module.exports = __webpack_public_path__ + "img/first3.37f6bb41.png";